import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { AuthGate } from "./components/auth-gate";
import { AppShell } from "./components/app-shell";
import { ErrorBoundary } from "./components/error-boundary";
import { EmptyState } from "./components/page";
import { ThemeProvider } from "./components/theme";

const TodayPage = lazy(() => import("./pages/today-page").then((m) => ({ default: m.TodayPage })));
const PlanPage = lazy(() => import("./pages/plan-page").then((m) => ({ default: m.PlanPage })));
const ExecutionPage = lazy(() => import("./pages/execution-page").then((m) => ({ default: m.ExecutionPage })));
const PerformancePage = lazy(() => import("./pages/performance-page").then((m) => ({ default: m.PerformancePage })));
const EnergyPage = lazy(() => import("./pages/energy-page").then((m) => ({ default: m.EnergyPage })));
const ReportsPage = lazy(() => import("./pages/reports-page").then((m) => ({ default: m.ReportsPage })));
const OfficePage = lazy(() => import("./pages/office-page").then((m) => ({ default: m.OfficePage })));
const AuditPage = lazy(() => import("./pages/audit-page").then((m) => ({ default: m.AuditPage })));
const EcosystemPage = lazy(() => import("./pages/ecosystem-page").then((m) => ({ default: m.EcosystemPage })));
const ProfilePage = lazy(() => import("./pages/profile-page").then((m) => ({ default: m.ProfilePage })));
const VesselLandingPage = lazy(() => import("./pages/vessel-landing-page").then((m) => ({ default: m.VesselLandingPage })));

function RouteLoading() {
  return (
    <div className="mx-auto flex max-w-6xl flex-col gap-4">
      <div className="h-8 w-48 animate-pulse rounded bg-muted" />
      <div className="grid gap-4 md:grid-cols-3">
        <div className="h-28 animate-pulse rounded-lg bg-muted" />
        <div className="h-28 animate-pulse rounded-lg bg-muted" />
        <div className="h-28 animate-pulse rounded-lg bg-muted" />
      </div>
    </div>
  );
}

function NotFoundPage() {
  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="sr-only">Page not found</h1>
      <EmptyState title="Page not found">Use the sidebar to return to a NavioPlan workspace page.</EmptyState>
    </div>
  );
}

// F0.6 app shell — auth-gated, domain nav per master spec §2. Domain content lands M1+.
export function App() {
  return (
    <ThemeProvider>
      <AuthGate>
        <ErrorBoundary>
          <Suspense fallback={<RouteLoading />}>
            <Routes>
            <Route element={<AppShell />}>
              <Route index element={<TodayPage />} />
              <Route path="plan" element={<PlanPage />} />
              <Route path="execution" element={<ExecutionPage />} />
              <Route path="underway" element={<ExecutionPage />} />
              <Route path="performance" element={<PerformancePage />} />
              <Route path="energy" element={<EnergyPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="office" element={<OfficePage />} />
              <Route path="audit" element={<AuditPage />} />
              <Route path="ecosystem" element={<EcosystemPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="v/:vesselId" element={<VesselLandingPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </AuthGate>
    </ThemeProvider>
  );
}
